// src/utils/imageUtils.js

export const dataURLtoFile = (dataurl, filename) => {
    if (!dataurl || typeof dataurl !== 'string') {
        console.warn("dataURLtoFile received invalid input:", dataurl);
        return null;
    }

    try {
        let arr = dataurl.split(',');
        let mime = 'image/png'; // Default fallback
        let bstr;

        // Case 1: Standard Data URL (e.g., "data:image/png;base64,.....")
        if (arr.length > 1 && arr[0].includes('data:') && arr[0].includes('base64')) {
            const mimeMatch = arr[0].match(/:(.*?);/);
            if (mimeMatch) {
                mime = mimeMatch[1];
            }
            bstr = atob(arr[1]);
        } 
        // Case 2: Raw Base64 string (no prefix) or malformed prefix
        else {
            // Try to decode the whole string or the second part if split worked but regex failed
            const stringToDecode = arr.length > 1 ? arr[1] : dataurl;
            try {
                bstr = atob(stringToDecode);
            } catch (e) {
                console.error("Failed to decode base64 string");
                return null;
            }
        }

        let n = bstr.length;
        let u8arr = new Uint8Array(n);
        
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        
        return new File([u8arr], filename, {type:mime});
    } catch (error) {
        console.error("Error in dataURLtoFile:", error);
        return null;
    }
}